"use strict"

////////////////////////////////////////////////
// VŠECHNY STATIKY ODTEĎ POUZE MALÝMI PÍSMENY //
////////////////////////////////////////////////

import {Messages} from './messages.js';

const A = document.createElement('a');

export const Handlers = {

    pushurl:(action, options, vutajax, ajax)=>{
        if (options.history == 'is_popstate') return;
        if (!options.history) throw "Zakázáno ukládat historii";
        if (ajax.isPost) throw "Nelze ukládat state POST requestu";
        if (!vutajax.selector) throw "Nelze ukládat state instance bez platného selectoru";

        // přeparsování url na absolutní přes element typu a //
        A.href = action.url || ajax.requested_url;

        if (!history.state?.VutAjax) {
            let state = history.state ?? {};
            state.VutAjax = {selector : vutAjax.selector}
            if (action.replace_first) {
                window.history.replaceState(state, null, A.href);
                return;
            }
            window.history.replaceState(state, null);
        }

        window.history[window.location.href.split('#')[0] === A.href.split('#')[0] ? 'replaceState' : 'pushState']({
            VutAjax:{
                selector : vutajax.selector,
            }
        }, null, A.href);
    },

    replacecontent:(action)=>{

        let elList = document.querySelectorAll(action.selector);

        Object.keys(elList).forEach((key)=>{
            elList[key].innerHTML = action.content||'';
            exec_body_scripts(elList[key]);
        });

    },

    appendcontent:(action)=>{

        [...document.querySelectorAll(action.selector)].forEach((e)=>{
            e.insertAdjacentHTML('beforeend', action.content);
            exec_body_scripts(e);
        });

    },

    'function':(action)=>{
        // zavolani JS funkce v aktualnim/globalnim kontextu
        let fn=(context, fnName)=>{ // rekurzivní nalezení zanořené funkce, např. window.console.log
            if (typeof context[fnName]=='function') return context[fnName];
            else if (typeof fnName=='string') {
                let c=fnName.split('.')[0];
                let f=fnName.split('.').reduce((t,v,i)=>t+=i?v:'', '');
                if (context[c]&&f) return fn(context[c], f);
            }
        }
        let r;
        r=fn(window, action.fnName);
        if (typeof r == 'function') {
            r(action.fnData);
        } else {
            console.error("Pokus o volani neexistujici funkce: ", action.fnName);
        }

    },

    vutmessages:(action)=>{
        console.info('messages v kontextu '+action.context+':', action.content);
    },

    datagrid2:(action)=>{
        try {
            initDatagrid2.grid(action.id)[action.action](action.data ?? null);
        } catch(e) {console.error('VutAjax: chyba Datagrid2 akce:', e);}
    },

    vutbox:(action)=>{
        try {
            if (action.id) {
                VutBox.box(action.id)[action.action](action.data||null);
            } else {
                VutBox[action.action](action.data||null);
            }
        }
        catch(e) {console.error('VutAjax: chyba VutBox akce:', e);}
    },

    jqaction:(action)=>{
        if(typeof jQuery  ==='function' && typeof jQuery(action.selector)[action.fnName] === 'function'){
            jQuery(action.selector)[action.fnName](action.fnData);
        }else{
            console.error("Pokus o volani neexistujici jQuery funkce: $("+action.selector+').', action.fnName);
        }
    },

    /*********************************************************************/
    /**** reload a redirect se zpožděním, aby doběhly ostatní obsluhy ****/
    /**** např. datagrid2 hromadná akce, aby se odemkl unload stránky ****/
    reload:(action)=>{
        setTimeout(()=>window.location.reload(), 50);
    },

    redirect:(action)=>{
        if(action.url) {
            setTimeout(()=>window.location = action.url, 50);
        }
    },
    /*********************************************************************/

    message:(action)=>{
        if (action.data&&(typeof action.data==="object")&&action.data.message) {
            Messages.render(action.data);
        }
    },

    modal: (action) => {
        // ignore -> jen aby to nervalo v konzoli -> poreseno pres naja
    }
}

export const exec_body_scripts=(body_el)=>{

    [...body_el.querySelectorAll('script')].forEach((e)=>{
        try {
            let parent=e.parentNode;
            e.remove();
            let script=document.createElement('script');
            script.setAttribute('name', 'vutajax-eval-script');
            if (e.src) {script.src=e.src||"";}
            else if (e.innerHTML) {script.innerHTML=e.innerHTML;}
            parent.appendChild(script);
        } catch(er) {
            console.error("VutAjax: chyba skriptu:", er);
        }

    });
}